module.exports = __webpack_public_path__ + "img/eplus.f1e49853.png";